import auditLead from '@hc-frontend/shared-assets/src/exit-messaging/experiences/modal-connectme-input/auditLead'
import trackAnswers from 'core/services/trackAnswers'
import store from 'utils/store/withMiddleware'
import saveToStorage from './saveToStorage'
import { dateToString } from '@hc-frontend/utils'

async function subscribeAndSaveApplicant(valuesForm) {
  const hcStorage = saveToStorage(valuesForm)
  const promises = [
    trackAnswers(hcStorage, {
      coverage_start: dateToString(valuesForm.sdate)
    })
  ]

  if (
    window.LeadiD &&
    window.LeadiD.token &&
    valuesForm.showPhoneInput &&
    valuesForm.phone
  ) {
    promises.push(auditLead())
  }

  return Promise.all(promises).then(responses => {
    store.update({ hcStorage })
    return [...responses]
  })
}

export default subscribeAndSaveApplicant
